import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["fileInput", "fileList", "template"];

  connect() {
    this.categoryIndices = {};
    this.loadExistingFiles();
  }

  loadExistingFiles() {
    console.log(this.element.dataset.files)
    const files = this.element.dataset.files ? JSON.parse(this.element.dataset.files) : [];
    files.forEach((file) => {
      this.addExistingFile(file);
    });
  }

  addExistingFile(file) {
    const template = this.templateContent();
    const recordType = this.element.dataset.recordType;
    const index = file.id;

    template.querySelector(".file-name").textContent = file.og_file_name;
    template.querySelector(".description").value = file.description || "";
    template.querySelector(".category-hidden-input").value = file.category;
    template.querySelector(".category-hidden-input").name = `${recordType}[file_records_attributes][${index}][category]`;
    template.querySelector(".description").name = `${recordType}[file_records_attributes][${index}][description]`;

    const deleteButton = template.querySelector("button[data-action='click->file-upload#deleteFile']");
    deleteButton.setAttribute("data-file-id", file.id);

    this.fileListTarget.appendChild(template);
  }

  triggerFileInput() {
    this.fileInputTarget.click();
  }

  addFile(event) {
    const files = event.target.files;
    const category = this.element.dataset.category;
    const recordType = this.element.dataset.recordType;
  
    if (!this.categoryIndices[category]) {
      this.categoryIndices[category] = 0;
    }
  
    for (const file of files) {
      const template = this.templateContent();
      const index = `new_${category}_${this.categoryIndices[category]}`;
  
      template.querySelector(".file-name").textContent = file.name;
      template.querySelector(".description").value = file.name.replace(/\.[^/.]+$/, ""); // Set default description
      template.querySelector(".category-hidden-input").value = category;
      template.querySelector(".category-hidden-input").name = `${recordType}[file_records_attributes][${index}][category]`;
      template.querySelector(".description").name = `${recordType}[file_records_attributes][${index}][description]`;
  
      // Clone the original file input
      const hiddenFileInput = document.createElement("input");
      hiddenFileInput.type = "file";
      hiddenFileInput.name = `${recordType}[file_records_attributes][${index}][file]`;
      hiddenFileInput.classList.add("hidden");
  
      // Create a new FileList containing only the current file
      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(file);
      hiddenFileInput.files = dataTransfer.files; // Attach the single file
  
      // Add the hidden file input to the template
      const fileHiddenInputContainer = template.querySelector(".file-hidden-input");
      fileHiddenInputContainer.parentNode.replaceChild(hiddenFileInput, fileHiddenInputContainer);
  
      const ogFileNameInput = document.createElement("input");
      ogFileNameInput.type = "hidden";
      ogFileNameInput.name = `${recordType}[file_records_attributes][${index}][og_file_name]`;
      ogFileNameInput.value = file.name;
  
      const fileTypeInput = document.createElement("input");
      fileTypeInput.type = "hidden";
      fileTypeInput.name = `${recordType}[file_records_attributes][${index}][file_type]`;
      fileTypeInput.value = file.name.split('.').pop();
  
      // Attach the additional inputs to the file-item container
      const fileItemContainer = hiddenFileInput.closest('.file-item');
      fileItemContainer.appendChild(ogFileNameInput);
      fileItemContainer.appendChild(fileTypeInput);
  
      // Set delete button data attribute
      const deleteButton = template.querySelector("button[data-action='click->file-upload#deleteFile']");
      deleteButton.setAttribute("data-file-id", index);
  
      // Append the template to the file list target
      this.fileListTarget.appendChild(template);
      this.categoryIndices[category] += 1;
    }
  
    // Clear the original file input
    this.fileInputTarget.value = "";
  }
  
  templateContent() {
    const template = this.templateTarget;
    return template.content.cloneNode(true);
  }
  
  deleteFile(event) {
    const fileId = event.target.getAttribute("data-file-id");

    if (!fileId) {
      console.error("Missing file ID for deletion");
      return;
    }

    if (confirm('Are you sure you want to delete this file?')) {
      if (fileId.startsWith('new_')) {
        event.target.closest('.file-item').remove();
      } else {
        this.deleteFileFromBackend(fileId, event);
      }
    }

    this.fileInputTarget.value = "";
  }

  async deleteFileFromBackend(fileId, event) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute("content");
   
    const accId = this.element.dataset.accId;
    const recordType = this.element.dataset.recordType;
    const accUserId = this.element.dataset.accUserId;

    try {
      const response = await fetch(`/accounts/${accId}/${recordType}s/${accUserId}/file_records/${fileId}`, {
        method: 'DELETE',
        headers: {
          'X-CSRF-Token': csrfToken,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const data = await response.json();
        event.target.closest('.file-item').remove();
        //console.log(data.message); // Optionally log the success message
      } else {
        const data = await response.json();
        alert(data.message || 'Failed to delete the file.');
      }
    } catch (error) {
      console.error('Error deleting file:', error);
      alert('An error occurred while deleting the file.');
    }
  }
}


